import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/js/docbookHref'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import VueI18n from 'vue-i18n'
import en from '@/js/language/en'
import zh from '@/js/language/zh'
import NativeBridge from '@/js/nativeBridge'


Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
Vue.use(VueI18n)


const i18n = new VueI18n({
    locale: 'zh', // 语言标识
    messages: {
        en,
        zh
    }
})

const vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
const bridge = new NativeBridge({
    vm
})

Vue.prototype.$nativeBridge = bridge



window.native2js = function (message) {
    if (!message) return
    return bridge.handleMessage(message)
}

export default vm
